module.exports = __webpack_public_path__ + "img/snow_fall_00006.56243f5e.png";